export const decodeMetadata = <T = any>(str: string): T => {
  const rawBase64Str = str.slice(29);
  const metadata = JSON.parse(window.atob(rawBase64Str));
  return metadata;
};